<template>
    <div class="notifier" :class="{ visible: messages.length > 0}">

        <div :key="'notis'+index" v-for="(message, index) in messages" class="note">
            <img src="images/company-portal/is-valid-icon.svg">{{ message.text }}
        </div>

    </div>
</template>

<script>
export default {

    data () {
        return {
            messages: []
        }
    },

    created () {
        bus.$on('notify', (text) => {
            console.log('got notify from bus')

            const notification = { id: new Date().getTime(), text: text }

            console.log(notification)

            this.toggle(notification)
        })
    },

    methods: {
        toggle (notification) {
            this.messages.push(notification)

            setTimeout(() => {
                this.messages = this.messages.filter(m => m.id !== notification.id)
            }, 6000)
        }
    }
}
</script>
